import dayjs from 'dayjs';
import { DATE_FORMAT_DAY_JS } from '@discover-lib/dateFormats';

export default function todayInTimeZone(timeZone?: string) {
  return timeZone ? dayjs().tz(timeZone) : dayjs();
}

export function todayDateInTimeZone(timeZone?: string) {
  return todayInTimeZone(timeZone).format(DATE_FORMAT_DAY_JS);
}
